import { useMemo } from "react";
import type { CubeQuery } from "@models/ISchema";
import { getAnnualGroups, getAnnualWeeks } from "../../adapters";
import type { AnnualSchedulePeriod } from "../../types";

/**
 * Adapts the package response shared with the other package views into annual rows and weeks.
 *
 * @param cube - Package response, including annual fields when the annual tab is active.
 * @param period - Period used to filter weeks locally; null shows all weeks.
 * @returns League groups and visible weeks for the matrix.
 *
 * @remarks Changing the period only filters the weeks; it does not request the package again.
 */
export const usePackageAnnualSchedule = (cube: CubeQuery | null, period: AnnualSchedulePeriod) => {
  const groups = useMemo(() => getAnnualGroups(cube), [cube]);
  const weeks = useMemo(() => getAnnualWeeks(cube?.editorWeeks, period), [cube, period]);

  return { groups, weeks };
};
